import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import reloadDebugger from '../utils/reloadDebugger'

/**
 * Component to track React Router navigation
 * Must be placed inside Router component
 */
const NavigationTracker = () => {
  const location = useLocation()

  useEffect(() => {
    // Track navigation changes
    reloadDebugger.trackRouterNavigation(
      location.pathname,
      location.search,
      location.state
    )
  }, [location])

  return null
}

export default NavigationTracker

